// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';
import {addRemoveModalClass} from '../../../shared/services/add-remove-modal-class';
import {downloadSmartForm} from '../../../shared/services/download-smart-form';
import {routerActions} from 'react-router-redux';

export const updateRegistrationModals = (property, isVisible) =>

    dispatch => {

        if (property === 'customerSearchModal' || property === 'confirmDeleteModal') {

            addRemoveModalClass(isVisible);

        }

        dispatch({
            isVisible,
            property,
            type: actions.UPDATE_PRODUCT_REGISTRATION_MODALS
        });

    };

export const updateStatusChangeModalVisibility = isVisible =>

    dispatch => {

        addRemoveModalClass(isVisible);

        dispatch({
            isVisible,
            type: actions.UPDATE_PRODUCT_REGISTRATION_STATUS_CHANGE_MODAL
        });

    };

export const updatePrintRegistrationFormModal = (isVisible, route, registrationId) =>

    dispatch => {

        addRemoveModalClass(isVisible);

        dispatch({
            isVisible,
            registrationId,
            route,
            type: actions.UPDATE_PRODUCT_REGISTRATION_PRINT_REGISTRATION_MODAL
        });

    };

export const printRegistrationForm = (id, route) =>

    async dispatch => {

        const regId = id.split('-')[1];

        dispatch(routerActions.push(route));
        updatePrintRegistrationFormModal(false, '#', '')(dispatch);

        try {

            await downloadSmartForm('REGISTRATION', regId);

        } catch (error) {

            throw error;

        }

    };

export const closePrintRegistrationFormModal = route =>

    dispatch => {

        dispatch(routerActions.push(route));
        updatePrintRegistrationFormModal(false, '#', '')(dispatch);

    };



// WEBPACK FOOTER //
// ./src/product/product-registration/action-creators/registration-modals.js